/**
 * Format utilities
 */

import { format, parseISO } from "date-fns";

export function emptyToUndefined(value: string): string | undefined {
    return value.trim() || undefined;
}

export function formatProfileDateTime(value: string): string {
    return format(parseISO(value), "d MMM yyyy, HH:mm");
}

export function formatCardExpiry(month: number, year: number): string {
    return `${String(month).padStart(2, "0")}/${String(year).slice(-2)}`;
}

/*
 * 10 thousand is the limit in paginated hits
 * https://opensearch.org/docs/2.11/search-plugins/searching-data/paginate/#scroll-search
 */
export function formatTotal(total: number) {
    return total < 10000 ? total : `${total}+`;
}
